export default {
    props: {
        actionLabel: String,
        index: Number,
        modelId: Object,
        modelObject: Object,
        title: String,
        editMode: Boolean
    },

    data: function () {
        return {
            loading: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {},
        }
    },

    computed: {},

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }

            return this.modelErrors[field];
        },

        emptyModel() {
            return {
                Id: 0,
                Code: null,
                Quantity: null,
        }
        },

        show() {
            this.model = this.modelObject ?? this.emptyModel();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            this.$emit('hide');
        },

        async onOkClick() {
            let validateResult = await this.$refs.modelForm.validate();
            if (validateResult) {
                this.$emit('ok', { index: this.index, model: this.model, files: null });
                this.hide();
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}